const RoutePrivileges = {
  ANYONE: 0,
  GUEST: 1,
  AUTHENTICATED: 2,
};

export default RoutePrivileges;
